interface SearchButtonProps {
  handleSearchButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const SearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.995 21.288L15 14.291C17.5912 11.3183 17.3604 6.82674 14.478 4.13529C11.5957 1.44385 7.09887 1.52083 4.31034 4.30937C1.52181 7.0979 1.44482 11.5947 4.13627 14.477C6.82772 17.3594 11.3192 17.5902 14.292 14.999L21.289 21.995L21.995 21.288ZM9.50002 15.8C6.02062 15.8 3.20002 12.9794 3.20002 9.50004C3.20002 6.02065 6.02062 3.20004 9.50002 3.20004C12.9794 3.20004 15.8 6.02065 15.8 9.50004C15.7962 12.9778 12.9778 15.7962 9.50002 15.8Z"
      fill="#6A6A6A"
    />
  </svg>
);

export const SearchButton = ({
  handleSearchButtonClick,
}: SearchButtonProps) => {
  return (
    <button
      onClick={handleSearchButtonClick}
      style={{
        background: 'none',
        border: 'none',
        paddingRight: '5px',
        cursor: 'pointer',
      }}
      aria-description="Search for address"
      aria-label="Search for address"
    >
      <SearchIcon />
    </button>
  );
};
